import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { UserSettingsService } from './services';
import { UserSetting } from './models';

import { ToastService, ToastType } from '../shared/toast/toast.service';
import { LoadingPanelService, LoadingPanelSettings } from '../shared/loading-panel/loading-panel.service';
import { UserProfileComponent } from './user-profile.component';
import { FormsModule } from '@angular/forms';

@Component({
    templateUrl: './user-my-profile.component.html',
    selector: 'ep-my-user-profile',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [UserProfileComponent, FormsModule]
})

export class MyUserProfileComponent implements OnInit {

    constructor(private userSettingsService: UserSettingsService, private loadingPanelService: LoadingPanelService, private toastService: ToastService) { }

    private SettingKey_Grid_SelectionMode: string = 'Setting_Grid_SelectAllMode';
    private SettingKey_Grid_ShowFilterRow: string = 'Setting_Grid_ShowFilterRow';
    //private SettingKey_Chart_Refreshtime: string = 'Setting_Chart_Refreshtime';

    public errors: string[];
    public enableChartRefreshTime: boolean = false;
    gridSelectionModeSetting: UserSetting = new UserSetting(this.SettingKey_Grid_SelectionMode, '', 'allPages');
    gridShowFilterRowSetting: UserSetting = new UserSetting(this.SettingKey_Grid_ShowFilterRow, '', 'false');
    //chartRefreshtimeSetting: UserSetting = new UserSetting(this.SettingKey_Chart_Refreshtime, '', 'false', '5'); //disable the key by default with 5 seconds time to refresh

    ngOnInit(): void {
        this.resetErrors();
        var promises = [];
        promises.push(this.userSettingsService.getSingleSetting(this.SettingKey_Grid_SelectionMode).then(setting => this.gridSelectionModeSetting = setting || this.gridSelectionModeSetting));
        promises.push(this.userSettingsService.getSingleSetting(this.SettingKey_Grid_ShowFilterRow).then(setting => this.gridShowFilterRowSetting = setting || this.gridShowFilterRowSetting));
        //promises.push(this.userSettingsService.getSingleSetting(this.SettingKey_Chart_Refreshtime).then(setting => {
        //    this.chartRefreshtimeSetting = setting || this.chartRefreshtimeSetting;
        //    this.enableChartRefreshTime = this.chartRefreshtimeSetting.Value1.toLowerCase() == "true";
        //}));
        
        this.loadingPanelService.showLoadingPanelDirect('Loading user specific settings');
        observableForkJoin(promises).toPromise().then(() => {
            this.loadingPanelService.hideLoadingPanel();
        });
    }

    resetErrors() {
        this.errors = [null,null];
    }

    async saveSettings(): Promise<void> {
        this.resetErrors();        
        //this.chartRefreshtimeSetting.Value1 = this.enableChartRefreshTime.toString();
        //if (this.enableChartRefreshTime) {
        //    if (this.chartRefreshtimeSetting.Value2 == null || this.chartRefreshtimeSetting.Value2.length < 1) {
        //        this.errors[0] = "The Chart Refreshtime cannot be empty";
        //    }
        //    else if (parseInt(this.chartRefreshtimeSetting.Value2) < 1) {
        //        this.errors[0] = "Value must be 1 or higher";
        //    }
        //    var pattern = /^\d+$/;
        //    if (!pattern.test(this.chartRefreshtimeSetting.Value2)) {
        //        this.errors[1] = "Please enter number only";
        //    }

        //    this.chartRefreshtimeSetting.Value2 = this.chartRefreshtimeSetting.Value2?.toString();
        //}
        if (this.errors.every(e => !e)) {
            var settings = [];
            settings.push(this.gridShowFilterRowSetting);
            settings.push(this.gridSelectionModeSetting);
            //settings.push(this.chartRefreshtimeSetting);
            var deletes: string[] = [];

            this.loadingPanelService.showLoadingPanelDirect('Saving user specific settings');
            try {
                await this.userSettingsService.saveSettings(settings);
                await Promise.all(deletes.map(key => this.userSettingsService.deleteSetting(key)));
                this.toastService.showToast('Settings saved successfully', ToastType.success);
            }
            catch (error) { }
            finally {
                this.loadingPanelService.hideLoadingPanel();
            }

        }
    }
}
